var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("template", {
    slot: "header"
  }, [_vm._v("Header")]), _vm._v(" 111 "), _c("template", {
    slot: "footer"
  }, [_vm._v("Footer")])], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };